import { SvgIcon , SvgIconProps} from '@mui/material';
import './ccf-add-notes-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAddNotesIconProps extends SvgIconProps  {}

/**
 * Component used to show add notes icon in text editor
 * @param props -CcfAddNotesIconProps
 * @example <CcfAddNotesIcon />
 * @returns
 */
export function CcfAddNotesIcon(props: CcfAddNotesIconProps) {
  return (
    <SvgIcon
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.4 0.8H11.2V0H4.8V0.8H1.6C0.72 0.8 0 1.52 0 2.4V14.4C0 15.28 0.72 16 1.6 16H14.4C15.28 16 16 15.28 16 14.4V2.4C16 1.52 15.28 0.8 14.4 0.8ZM14.4 14.4H1.6V2.4H4.8V3.2H11.2V2.4H14.4V14.4Z"
        fill="#526B7A"
      />
      <path d="M3.2 4.8H12.8V6.4H3.2V4.8Z" fill="#526B7A" />
      <path d="M3.2 8H12.8V9.6H3.2V8Z" fill="#526B7A" />
      <path d="M3.2 11.2H9.6V12.8H3.2V11.2Z" fill="#526B7A" />
    </SvgIcon>
  );
}

export default CcfAddNotesIcon;
